import { useEffect, useState } from 'react';

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [label, setLabel] = useState('');
  const [isHovering, setIsHovering] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
      if (!isVisible) setIsVisible(true);
    };

    const handleMouseOver = (e) => {
      const target = e.target;
      const interactive =
        target.tagName === 'BUTTON' ||
        target.tagName === 'A' ||
        target.tagName === 'INPUT' ||
        target.closest('button') ||
        target.closest('a');

      if (interactive) {
        setIsHovering(true);
        // Custom labels via data-cursor or element type
        const cursorLabel = target.getAttribute?.('data-cursor') ||
                            target.closest('[data-cursor]')?.getAttribute('data-cursor');
        if (cursorLabel) {
          setLabel(cursorLabel);
        } else if (target.tagName === 'INPUT' || target.closest('input')) {
          setLabel('TYPE');
        } else {
          setLabel('TAP');
        }
      } else {
        setIsHovering(false);
        setLabel('');
      }
    };

    const handleMouseLeave = () => setIsVisible(false);
    const handleMouseEnter = () => setIsVisible(true);

    window.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseover', handleMouseOver);
    document.addEventListener('mouseleave', handleMouseLeave);
    document.addEventListener('mouseenter', handleMouseEnter);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseover', handleMouseOver);
      document.removeEventListener('mouseleave', handleMouseLeave);
      document.removeEventListener('mouseenter', handleMouseEnter);
    };
  }, [isVisible]);

  return (
    <>
      <div
        className={`cursor-dot ${isHovering ? 'hover' : ''}`}
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
          opacity: isVisible ? 1 : 0,
        }}
      />
      {isHovering && label && (
        <div
          className="cursor-label"
          style={{
            left: `${position.x + 24}px`,
            top: `${position.y + 24}px`,
          }}
        >
          {label}
        </div>
      )}
    </>
  );
};

export default CustomCursor;
